import { History } from 'history';
import { Action } from 'redux';

import {
  AxiosAction,
  isSuccessActionOf
} from '../middleware/axios';
import { isAction } from '../utils';

import {
  CheckpointTypeData,
  CheckpointTypeResponseDto
} from './state';

export interface GetCheckpointTypesParams {
  filter?: string;
  skip?: number;
  take?: number;
  transient?: boolean;
}

// Action Types

const GET_CHECKPOINT_TYPES = 'CHECKPOINT_TYPES.GET_ALL';
const GET_CHECKPOINT_TYPE = 'CHECKPOINT_TYPES.GET_ONE';
const GET_CHECKPOINT_TYPE_COUNT = 'CHECKPOINT_TYPES.COUNT';
const CLEAR_RECENTLY_MODIFIED = 'CHECKPOINT_TYPES.CLEAR_RECENTLY_MODIFIED';
const DELETE_CHECKPOINT_TYPE = 'CHECKPOINT_TYPE.DELETE';
const CREATE_CHECKPOINT_TYPE = 'CHECKPOINT_TYPES.CREATE';
const UPDATE_CHECKPOINT_TYPE = 'CHECKPOINT_TYPES.UPDATE';

// Action Interfaces

export interface UpdateCheckpointType extends AxiosAction<CheckpointTypeResponseDto> {
  type: typeof UPDATE_CHECKPOINT_TYPE;
}
export interface CreateCheckpointType extends AxiosAction<CheckpointTypeResponseDto> {
  type: typeof CREATE_CHECKPOINT_TYPE;
}
export interface GetCheckpointTypes extends AxiosAction<CheckpointTypeResponseDto[]> {
  transient: boolean;
  type: typeof GET_CHECKPOINT_TYPES;
}
export interface GetCheckpointTypeCount extends AxiosAction<{ count: number }> {
  type: typeof GET_CHECKPOINT_TYPE_COUNT;
}
export interface DeleteCheckpointType extends AxiosAction<void> {
  code: string;
  type: typeof DELETE_CHECKPOINT_TYPE;
}
export interface GetCheckpointType extends AxiosAction<CheckpointTypeResponseDto> {
  type: typeof GET_CHECKPOINT_TYPE;
}
export interface ClearRecentlyModified extends Action {
  type: typeof CLEAR_RECENTLY_MODIFIED;
}

// Action Creators

export function getCheckpointTypes(
  { filter, skip, take, transient }: GetCheckpointTypesParams
): GetCheckpointTypes {
  return {
    payload: {
      client: 'workManagement',
      request: {
        params: {
          filter,
          skip,
          take
        },
        url: '/checkpoint-types'
      }
    },
    transient: transient !== undefined ? transient : false,
    type: GET_CHECKPOINT_TYPES
  };
}
export const isGetCheckpointTypes = isAction<GetCheckpointTypes>(GET_CHECKPOINT_TYPES);
export const isGetCheckpointTypesSuccess = isSuccessActionOf<GetCheckpointTypes>(GET_CHECKPOINT_TYPES);

export function getCheckpointTypeCount(): GetCheckpointTypeCount {
  return {
    payload: {
      client: 'workManagement',
      request: {
        url: '/checkpoint-types/count'
      }
    },
    type: GET_CHECKPOINT_TYPE_COUNT
  };
}
export const isGetCheckpointTypeCount = isAction<GetCheckpointTypeCount>(GET_CHECKPOINT_TYPE_COUNT);
export const isGetCheckpointTypeCountSuccess = isSuccessActionOf<GetCheckpointTypeCount>(GET_CHECKPOINT_TYPE_COUNT);

export function deleteCheckpointType(
  code: string,
  onSuccess?: DeleteCheckpointType['onSuccess']
): DeleteCheckpointType {
  return {
    code,
    onSuccess,
    payload: {
      client: 'workManagement',
      request: {
        method: 'DELETE',
        url: `/checkpoint-types/${code}`
      }
    },
    type: DELETE_CHECKPOINT_TYPE
  };
}
export const isDeleteCheckpointType = isAction<DeleteCheckpointType>(DELETE_CHECKPOINT_TYPE);
export const isDeleteCheckpointTypeSuccess = isSuccessActionOf<DeleteCheckpointType>(DELETE_CHECKPOINT_TYPE);

export function createCheckpointType(
  data: CheckpointTypeData,
  history: History
): CreateCheckpointType {
  return {
    onSuccess: () => dispatch => dispatch(() => history.push('/checkpointtypes')),
    payload: {
      client: 'workManagement',
      request: {
        data,
        method: 'POST',
        url: '/checkpoint-types'
      }
    },
    type: CREATE_CHECKPOINT_TYPE
  };
}
export const isCreateCheckpointType = isAction<CreateCheckpointType>(CREATE_CHECKPOINT_TYPE);
export const isCreateCheckpointTypeSuccess = isSuccessActionOf<CreateCheckpointType>(CREATE_CHECKPOINT_TYPE);

export function updateCheckpointType(
  code: string,
  data: CheckpointTypeData,
  history: History
): UpdateCheckpointType {
  return {
    onSuccess: () => dispatch => dispatch(() => history.push('/checkpointtypes/')),
    payload: {
      client: 'workManagement',
      request: {
        data,
        method: 'PUT',
        url: `/checkpoint-types/${code}`
      }
    },
    type: UPDATE_CHECKPOINT_TYPE
  };
}
export const isUpdateCheckpointType = isAction<UpdateCheckpointType>(UPDATE_CHECKPOINT_TYPE);
export const isUpdateCheckpointTypeSuccess = isSuccessActionOf<UpdateCheckpointType>(UPDATE_CHECKPOINT_TYPE);

export function getCheckpointType(code: string): GetCheckpointType {
  return {
    payload: {
      client: 'workManagement',
      request: {
        method: 'GET',
        url: `/checkpoint-types/${code}`
      }
    },
    type: GET_CHECKPOINT_TYPE
  };
}
export const isGetCheckpointType = isAction<GetCheckpointType>(GET_CHECKPOINT_TYPE);
export const isGetCheckpointTypeSuccess = isSuccessActionOf<GetCheckpointType>(GET_CHECKPOINT_TYPE);

export function clearRecentlyModified() {
  return {
    type: CLEAR_RECENTLY_MODIFIED
  };
}
export const isClearRecentlyModified = isAction<ClearRecentlyModified>(CLEAR_RECENTLY_MODIFIED);
